var alignment_rtlignore_default = {
  "alignLeft": "DRlMN",
  "textWrapNowrap": "dLwD3",
  "alignRight": "Wbi0P",
  "alignCenter": "OOSxy",
  "sizeFullWidth": "EqtyA",
  "renderedInTable": "GskfQ",
  "sizeOriginal": "Uk-up",
  "sizeContent": "Gd9ee",
  "sizeSmall": "uFfA5",
  "sizeSmallCenter": "xh-Rj",
  "flex": "TrphY",
  "LEFT": "_4YjjX",
  "CENTER": "QxJ3E",
  "RIGHT": "cxX-G",
  "AUTO": "d-MNq",
  "JUSTIFY": "gjiqH"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
